import { render, staticRenderFns } from "./WorkPlanAdd.vue?vue&type=template&id=d4e96786&scoped=true&"
import script from "./WorkPlanAdd.vue?vue&type=script&lang=js&"
export * from "./WorkPlanAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e96786",
  null
  
)

export default component.exports